<!-- Modal -->
<!--suppress AngularUndefinedBinding -->
<div class="modal fade" #modalElm tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content" *ngIf="newSubAccountRequest">
      <div class="modal-header">
        <h5 class="modal-title">{{ 'New Sub Account Request' | translate }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">x</button>
      </div>
      <div class="modal-body">
        <div class="form-group mb-3">
          <label translate>No of sub-accounts</label>
          <div class="input-group">
            <input type="number" class="form-control" [(ngModel)]="newSubAccountRequest.count" name="subAccountCount" aria-label="No of sub-accounts" readonly>
            <div class="input-group-append"><span class="input-group-text" id="basic-addon2" translate>Sub Account</span></div>
          </div>
        </div>
        <div class="form-group">
          <label translate>Justification</label>
          <textarea class="form-control" readonly name="justification" rows="3">{{ newSubAccountRequest.justification }}</textarea>
        </div>
        <div class="form-group" *ngIf="newSubAccountRequest.approved">
          <label translate>Approval Date</label>
          <input class="form-control" name="status" translate [ngModel]="newSubAccountRequest.decisionDate |date :'yyyy/MM/dd'" readonly/>
        </div>
        <div class="form-group">
          <label translate>Status</label>
          <input class="form-control" name="status" translate [ngModel]="checkStatus() | translate" readonly/>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn" data-dismiss="modal" translate><i class="flaticon-cancel-12"></i>{{ 'Close' | translate }}</button>
        <button type="button" *ngIf="!loading && (checkStatus() == 'Pending Approval' || checkStatus() == 'Pending Payment')" (click)="cancelRequest()" class="btn btn-danger" translate>Cancel</button>
        <button type="button" (click)="payRequest()" class="btn btn-primary" *ngIf="!loading && checkStatus() == 'Pending Payment'" translate>Pay</button>
        <button type="button" (click)="useRequest()" class="btn btn-primary" *ngIf="!loading && checkStatus() == 'Ready To Use'" translate>Use the request</button>
        <button type="button" class="btn btn-primary" *ngIf="loading" translate>
          <div class="mx-auto spinner-grow text-dark align-self-center loader-lg"></div>
        </button>
      </div>
    </div>
  </div>
</div>
<div class="modal" #infoModal tabindex="-1">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ modalTitle }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p>{{ modalMsg }}</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="okFunction? okFunction() : ''" translate>Close</button>
      </div>
    </div>
  </div>
</div>
<div class="modal" #confirmModal tabindex="-1">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" translate>{{ modalTitle | translate }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p translate>{{ modalMsg | translate }}</p>
      </div>
      <div class="modal-footer" *ngIf="yesFunction && noFunction">
        <button type="button" (click)="noFunction()" class="btn btn-primary" data-dismiss="modal" translate>No</button>
        <button type="button" (click)="yesFunction()" class="btn btn-primary" data-dismiss="modal" translate>Yes</button>
      </div>
    </div>
  </div>
</div>
<app-sub-accounts-payment-form #subAccountsPaymentForm></app-sub-accounts-payment-form>
